import { PUT } from "../../API/put";

export const rescheduleJobAccept = async (reschedule_job_id) => {
    const response = await PUT(`v3/reschedule-jobs/${reschedule_job_id}/approve`);
    return response?.status === "Success" ? response : null;
}